<template>
  <main :class="$store.getters['event/event'].theme_color" @click="collapseUserMenu">
    <Header />

    <NoticeArea :fixed="fixed" />

    <!-- main area -->
    <section class="mainArea_wrapper">
      <Left />

      <router-view />
    </section>
    <!-- /main area -->
  </main>
</template>

<script>
import Header from "../blocks/Header"
import Left from "../blocks/Left"
import NoticeArea from "../blocks/Notice"

export default {
  components: {Header, NoticeArea, Left},
  data() {
    return {
      fixed: false
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters["loading/loading"]
    }
  },
  methods: {
    handleScroll() {
      this.fixed = window.pageYOffset > 88
    },
    changeViewport() {
      if (this.$isMobile.apple.phone || this.$isMobile.apple.ipod) {
        let viewport = document.querySelector("meta[name='viewport']")
        if (viewport) {
          let viewportContent = viewport.getAttribute("content")
          viewport.setAttribute("content", viewportContent + ", user-scalable=no")
        }
      }
    },
    collapseUserMenu() {
      if (!this.$store.getters["userMenu/collapsed"]) return

      this.$store.dispatch("userMenu/collapse", false)
    }
  },
  mounted() {
    document.addEventListener("scroll", this.handleScroll)
    this.changeViewport()
  }
}
</script>

<style scoped>
@media screen and (min-width: 993px) {
  body {
    overflow-y: hidden;
  }
}
</style>
